module.exports = __webpack_public_path__ + "img/12.cec6788b.jpg";